import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import { REST_DAY_TYPE_TO_TRANSLATION_KEY } from '../../constants'
import CalendarFreeDay from './CalendarFreeDay'

type Props = {
  dayType: string
  startDateTime: string
  hideDate?: boolean
}

const getDayTypeTranslation = (dayType: string, t: TFunction) => {
  if (dayType === 'empty') return ''

  const translationKey = REST_DAY_TYPE_TO_TRANSLATION_KEY[dayType]
  return translationKey ? t(translationKey) : ''
}

const CalendarRestDay = ({ dayType, startDateTime, hideDate }: Props) => {
  const { t } = useTranslation()
  return (
    <CalendarFreeDay
      text={getDayTypeTranslation(dayType, t)}
      startDateTime={startDateTime}
      hideDate={hideDate}
    />
  )
}

export default CalendarRestDay
